/* LAMORE · lz behaviour: videos, carousels, modal, buy box, sticky bar, reveals. No dependencies. */
(function () {
  'use strict';
  var d = document;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  d.documentElement.classList.add('lz-js');
  function $$(sel, root) { return Array.prototype.slice.call((root || d).querySelectorAll(sel)); }
  function num(v) { var n = parseFloat(v); return isNaN(n) ? null : n; }

  /* ---------- videos ---------- */
  var io = null;
  function pauseBtn(v) { var h = v.parentElement; return h ? h.querySelector('[data-lz-pause]') : null; }
  function syncBtn(v) {
    var b = pauseBtn(v); if (!b) return;
    b.classList.toggle('is-paused', v.paused);
    b.setAttribute('aria-label', v.paused ? 'Play video' : 'Pause video');
  }
  function tryPlay(v) {
    if (v.preload === 'none') v.preload = 'auto';
    var p = v.play(); if (p && p.catch) p.catch(function () { syncBtn(v); });
  }
  function setupVideo(v) {
    if (v.dataset.lzReady) return; v.dataset.lzReady = '1';
    var start = num(v.dataset.start) || 0, end = num(v.dataset.end);
    v.muted = true; v.loop = false;
    v.addEventListener('loadedmetadata', function () { if (start && v.currentTime < start) v.currentTime = start; });
    v.addEventListener('timeupdate', function () {
      var stop = end || (v.duration ? v.duration - 0.2 : null);
      if (stop && v.currentTime >= stop) v.currentTime = start;
    });
    v.addEventListener('ended', function () { v.currentTime = start; if (!v.dataset.user) tryPlay(v); });
    v.addEventListener('play', function () { syncBtn(v); });
    v.addEventListener('pause', function () { syncBtn(v); });
    var b = pauseBtn(v);
    if (b && !b.dataset.lzReady) {
      b.dataset.lzReady = '1';
      b.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        if (v.paused) { delete v.dataset.user; tryPlay(v); } else { v.dataset.user = '1'; v.pause(); }
      });
    }
    if (reduce) { syncBtn(v); return; }
    if (io) io.observe(v); else tryPlay(v);
  }
  function initVideos(root) {
    if (!io && !reduce && 'IntersectionObserver' in window) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var v = en.target;
          if (v.dataset.user) return;
          if (en.isIntersecting && en.intersectionRatio >= 0.35) tryPlay(v);
          else if (!v.paused) v.pause();
        });
      }, { threshold: [0, 0.35, 0.7] });
    }
    $$('[data-lz-video]', root).forEach(setupVideo);
  }

  /* ---------- carousels (reels) ---------- */
  function initRails(root) {
    $$('[data-lz-reels]', root).forEach(function (sec) {
      if (sec.dataset.lzReady) return; sec.dataset.lzReady = '1';
      var rail = sec.querySelector('[data-lz-rail]');
      var prev = sec.querySelector('[data-lz-prev]'), next = sec.querySelector('[data-lz-next]');
      if (!rail) return;
      function step() { var c = rail.querySelector('.lz-reel'); return c ? c.getBoundingClientRect().width + 16 : 300; }
      function update() {
        var max = rail.scrollWidth - rail.clientWidth - 2;
        if (prev) prev.disabled = rail.scrollLeft <= 2;
        if (next) next.disabled = rail.scrollLeft >= max;
      }
      if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step() * 2, behavior: reduce ? 'auto' : 'smooth' }); });
      if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step() * 2, behavior: reduce ? 'auto' : 'smooth' }); });
      rail.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
      window.addEventListener('resize', update);
      update();

      /* modal with sound */
      var dlg = sec.querySelector('[data-lz-modal]');
      if (!dlg) return;
      var mv = dlg.querySelector('video');
      function open(card) {
        if (typeof dlg.showModal !== 'function') { window.open(card.dataset.src, '_blank'); return; }
        mv.src = card.dataset.src; if (card.dataset.poster) mv.poster = card.dataset.poster;
        dlg.showModal(); mv.currentTime = 0; mv.muted = false;
        var p = mv.play(); if (p && p.catch) p.catch(function () {});
      }
      function close() { mv.pause(); mv.removeAttribute('src'); mv.load(); if (dlg.open) dlg.close(); }
      sec.addEventListener('click', function (e) {
        var c = e.target.closest('[data-lz-open]'); if (c) { e.preventDefault(); open(c); }
      });
      sec.addEventListener('keydown', function (e) {
        var c = e.target.closest && e.target.closest('[data-lz-open]');
        if (c && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); open(c); }
      });
      dlg.querySelector('[data-lz-close]').addEventListener('click', close);
      var cl = dlg.querySelector('[data-lz-close-link]'); if (cl) cl.addEventListener('click', close);
      dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
      dlg.addEventListener('close', function () { mv.pause(); });
    });
  }

  /* ---------- gallery counter ---------- */
  function initGalleries(root) {
    $$('[data-lz-gal]', root).forEach(function (g) {
      if (g.dataset.lzReady) return; g.dataset.lzReady = '1';
      var t = g.querySelector('[data-lz-gal-track]'), out = g.querySelector('[data-lz-gal-i]');
      if (!t || !out) return;
      t.addEventListener('scroll', function () {
        var i = Math.round(t.scrollLeft / Math.max(1, t.clientWidth)) + 1; out.textContent = i;
      }, { passive: true });
    });
  }

  /* ---------- buy boxes ---------- */
  function initBuy(root) {
    $$('[data-lz-buy]', root).forEach(function (box) {
      if (box.dataset.lzReady) return; box.dataset.lzReady = '1';
      var idInput = box.querySelector('[data-lz-id]');
      var price = box.querySelector('[data-lz-price]');
      var cname = box.querySelector('[data-lz-color-name]');
      var add = box.querySelector('[data-lz-add]'), addLabel = box.querySelector('[data-lz-add-label]');
      var img = box.querySelector('.lz-colorimg');
      var sec = box.closest('.shopify-section') || d;
      var sColor = sec.querySelector('[data-lz-sticky-color]'), sPrice = sec.querySelector('[data-lz-sticky-price]'), sAdd = sec.querySelector('[data-lz-sticky-add]');
      $$('[data-lz-variant]', box).forEach(function (r) {
        r.addEventListener('change', function () {
          if (!r.checked) return;
          var ok = r.dataset.available === 'true';
          if (idInput) idInput.value = r.value;
          if (price) price.textContent = r.dataset.price;
          if (cname) cname.textContent = r.dataset.title;
          if (add) add.disabled = !ok;
          if (addLabel) addLabel.textContent = ok ? 'Add to cart' : 'Sold out';
          if (sColor) sColor.textContent = r.dataset.title;
          if (sPrice) sPrice.textContent = r.dataset.price;
          if (sAdd) sAdd.disabled = !ok;
          if (img && r.dataset.img) {
            img.classList.add('is-swapping');
            var pre = new Image();
            pre.onload = function () {
              img.removeAttribute('srcset'); img.src = r.dataset.img;
              if (r.dataset.srcset) img.srcset = r.dataset.srcset;
              img.classList.remove('is-swapping');
            };
            pre.src = r.dataset.img;
            var track = img.closest('[data-lz-gal-track]'); if (track) track.scrollTo({ left: 0, behavior: 'smooth' });
          }
          try { var u = new URL(window.location.href); if (u.pathname.indexOf('/products/') > -1) { u.searchParams.set('variant', r.value); history.replaceState(null, '', u); } } catch (e) {}
        });
      });
      $$('[data-lz-qty]', box).forEach(function (b) {
        b.addEventListener('click', function () {
          var inp = box.querySelector('[data-lz-qty-input]'); if (!inp) return;
          var v = Math.min(10, Math.max(1, (parseInt(inp.value, 10) || 1) + parseInt(b.dataset.lzQty, 10)));
          inp.value = v;
        });
      });
    });
  }

  /* ---------- sticky add to cart ---------- */
  function initSticky() {
    $$('[data-lz-stickybar]').forEach(function (bar) {
      if (bar.dataset.lzReady) return; bar.dataset.lzReady = '1';
      var sec = bar.closest('.shopify-section') || d;
      var target = sec.querySelector('.lz-buy__row');
      if (!target || !('IntersectionObserver' in window)) return;
      var footer = d.querySelector('footer, .shopify-section-group-footer-group');
      var past = false, footerOn = false;
      function set() {
        var on = past && !footerOn;
        bar.classList.toggle('is-on', on);
        bar.setAttribute('aria-hidden', on ? 'false' : 'true');
        var btn = bar.querySelector('button'); if (btn) btn.tabIndex = on ? 0 : -1;
      }
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { past = !e.isIntersecting && e.boundingClientRect.top < 0; set(); });
      }).observe(target);
      if (footer) new IntersectionObserver(function (es) { es.forEach(function (e) { footerOn = e.isIntersecting; set(); }); }).observe(footer);
    });
  }

  /* ---------- reveals ---------- */
  var RISE = '.lz-head, .lz-reel, .lz-tile, .lz-step, .lz-bento__item, .lz-why__item, .lz-results__intro, .lz-final__card, .lz-faq__side, .lz-acc--faq, .lz-buy--intro .lz-buy__media, .lz-buy--intro .lz-buy__info';
  function initRise(root) {
    var els = $$(RISE, root).filter(function (el) { return !el.classList.contains('lz-rise'); });
    if (reduce || !('IntersectionObserver' in window)) return;
    var groups = new Map();
    els.forEach(function (el) {
      var p = el.parentElement, i = groups.get(p) || 0; groups.set(p, i + 1);
      el.style.setProperty('--lz-d', Math.min(i, 5) * 0.08 + 's');
      el.classList.add('lz-rise');
    });
    var ob = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); ob.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
    els.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('is-in'); else ob.observe(el);
    });
    /* safety: never leave content hidden */
    setTimeout(function () { els.forEach(function (el) { if (el.getBoundingClientRect().top < window.innerHeight) el.classList.add('is-in'); }); }, 2500);
  }

  function boot(root) { initVideos(root); initRails(root); initGalleries(root); initBuy(root); initSticky(); initRise(root); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', function () { boot(d); }); else boot(d);
  d.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
